module.exports = __webpack_public_path__ + "static/media/racist_algo.221ddc70.webp";